import Experience from "../Experience";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger)

export default class IntroUI {
  constructor() {
    this.experience = Experience.getInstance()
    this.sizes = this.experience.sizes
    this.resources = this.experience.resources
    this.element = document.getElementById('cyber60-intro')
    this.videoEl = document.getElementById('cyber60-intro-video')
    this.maskEl = document.getElementById('cyber60-intro-mask')
    this.maskTopEl = document.getElementById('cyber60-intro-mask-top')
    this.maskBottomEl = document.getElementById('cyber60-intro-mask-bottom')
    this.scroller = window.scroller // LocomotiveScroll instance
    this.isMobile = this.scroller.scroll.isMobile;
    this.addListeners()
  }

  initMaskDesktop() {
    gsap.set(this.maskTopEl, {
      height: () => {
        return (window.innerHeight - (window.innerWidth / this.aspectRatio)) / 2
      },
      scaleY: 0
    })

    gsap.set(this.maskBottomEl, {
      height: () => {
        return (window.innerHeight - (window.innerWidth / this.aspectRatio)) / 2
      },
      scaleY: 0
    })

    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.element,
        start: 'top bottom',
        end: () => {
          return `+=${ window.innerHeight * 2 }`
        },
        scrub: true,
        invalidateOnRefresh: true,
        scroller: "[data-scroll-container]",
      }
    })
      .fromTo(this.maskEl, {
        y: () => {
          return -1 * window.innerHeight * 1.5
        }
      }, {
        y: () => {
          return -1 * window.innerHeight
        },
        duration: 1,
        ease: 'none'
      })
      .to(this.maskTopEl, {
        scaleY: 1,
        transformOrigin: 'top',
        duration: .5,
        ease: 'none'
      }, 1)
      .to(this.maskBottomEl, {
        scaleY: 1,
        transformOrigin: 'bottom',
        duration: .5,
        ease: 'none'
      }, 1)
      .to(this.maskEl, {
        scale: 50,
        duration: .5,
        ease: 'none'
      }, 1.5)
      .to(this.maskTopEl, {
        scaleY: 0,
        transformOrigin: 'top',
        duration: .4,
        ease: 'none'
      }, 1.5)
      .to(this.maskBottomEl, {
        scaleY: 0,
        transformOrigin: 'bottom',
        duration: .4,
        ease: 'none'
      }, 1.5)
  }

  initMaskMobile() {
    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.element,
        start: 'top bottom',
        end: () => {
          return `+=${ window.innerHeight * 2 }`
        },
        scrub: true,
        invalidateOnRefresh: true,
        scroller: "[data-scroll-container]",
      }
    })
      .fromTo(this.maskEl, {
        y: () => {
          return -1 * window.innerHeight * 1.5
        }
      }, {
        y: () => {
          return -1 * window.innerHeight
        },
        duration: 1,
        ease: 'none'
      })
  }

  initMask() {
    const maskHeight = 65.2
    const maskWidth = 425.2
    this.aspectRatio = maskWidth / maskHeight

    gsap.set(this.maskEl, {
      y: () => {
        return -1 * window.innerHeight * 1.5
      }
    })

    if(this.isMobile) {
      this.initMaskMobile()
    } else {
      this.initMaskDesktop()
    }
  }

  addListeners() {
    this.resources.on('ready', this.onResourcesLoaded.bind(this))
    this.scroller.on('scroll', this.onScroll.bind(this))
  }

  onScroll(e) {
    ScrollTrigger.update();
  }

  onResourcesLoaded() {
    this.initTexture()
    this.initMask()

    setTimeout(() => {
      this.refresh()
    }, 1000)
  }

  initTexture() {
    if(this.resources.items.videoTextureHero !== null) {
      this.videoTexture = this.resources.items.videoTextureHero
      this.video = this.videoTexture.videoElement.cloneNode(true)
      this.video.loop = true
      this.video.muted = true
      this.video.autoplay = true
      this.video.playsInline = true
      this.video.crossOrigin = 'anonymous'
      this.video.setAttribute('playsinline', '')
      this.video.setAttribute('muted', '')
      this.video.setAttribute('autoplay', '')
      this.video.setAttribute('loop', '')
      this.video.setAttribute('crossorigin', 'anonymous')
      this.video.setAttribute('preload', 'auto')
      this.video.setAttribute('webkit-playsinline', '')
      this.video.controls = false
      this.videoEl.appendChild(this.video)
      this.video.play();
      this.video.addEventListener('pause', () => {
        this.video.play()
      })
    }
  }

  refresh() {
    ScrollTrigger.refresh()
  }
}
